<mat-error class="mat-error-custom"
           *ngIf="formControlItem && (formControlItem.touched) && formControlItem.invalid">{{errorText}}</mat-error>
